<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>言語サービス　出版　メディア</h1>
                            <h2>ライティング品質と編集ワークフローの向上</h2>
                            <p>一貫性のある英文ライティング、迅速な出版や記事の公開、読者体験の向上などを実現。執筆の時間とコストを削減しながら、明快で統一感のあるブランディングが可能になります。
                            </p>
                            <div class="btn-group">
                                <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                                data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お問い合わせ</button>
                                <a href="https://calendly.com/trinkaai/meet" target="_blank"  id="autoEditGetStart" class="outline-btn">デモを予約する</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/language-services-publishing-and-media.png" alt="言語サービス　出版　メディア - 文法 チェック" class="img-fluid md50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd trinka-key-features">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>こんなお客様におすすめ</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="gt-features three-coloum">
                        <span class="hr-line d-sm-block d-none"></span>
                        <span class="vr-line l25"></span>
                        <span class="vr-line l50 d-sm-none"></span>
                        <span class="vr-line l75"></span>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>校正・校閲会社
                            </h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>マスコミ・出版社</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>ブロガー、ブログサイト運営者</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>翻訳サービス</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>編集プロダクション</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>マーケティング会社</h6>
                        </div>
                    </div>            
                </div>
            </div>
        </div>
    </section>
    
    
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>世界のトップ企業、学術機関もご利用</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/alternet.png" alt="alternet - 英文校正">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarperCollinsPublishers.png" alt="harper - 文法 チェック">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/scholastic.png" alt="scholastic - 英文チ ェッカー">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/RightlyWritten.png" alt="">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/sanchini.png" alt="sanchini - 英文校正">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/technica.png" alt="technica - ai英文校正">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/CapstoneWriting.png" alt="capstone writing - 英文校正">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/evolution_editing.png" alt="evolution editing - 文法 チェック">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>チームの英文を洗練するTrinka Enterpriseの機能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>Trinkaは、チーム全体が科学的なライティングの規範に従った、質の高い英文を作成するサポートをします。</p>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title  bt-none">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/BulkEditingOperations.svg" alt="一括校正 - 文法 チェック" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>一括校正</h3>
                            <p>MS Wordファイルをアップロードすれば、数分で文書全体の校正が完了。ダウンロードした校正済みファイルでは、修正提案は校閲の変更履歴に残り、確認して「承諾」するかしないかを選択できます。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/MedicalSpellCheckicon.svg" alt="文脈に沿ったスペルチェック - 英文チ ェッカー" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>文脈に沿ったスペルチェック</h3>
                            <p>Trinka内蔵のスペルチェッカーでは、類似したつづりの単語や、何百万もの専門用語を瞬時に判別。チームメンバーによる個人辞書の作成や単一辞書の共有もでき、一貫性のある英語でのブランド構築を可能にします。</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/WordCountreductions.png" alt="単語数削減 - 英文校正" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>単語数削減</h3>
                            <p>伝えたい意味をそこなわず、簡潔に伝える英文にスリムアップ。Trinkaを使い続けることで英文ライティングの技術も身に付きます。</p>
                        </div>
                    </div>

                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/Suggestionsthatmatchyourtone.png" alt="英文チ ェッカー" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>全体の文章のトーンに即した修正案</h3>
                            <p>カジュアルな文章でもフォーマルな文書でも、AIが適切な修正案を提案。論文でも、原著論文、レビュー、症例報告など、細かい種類の設定が可能です。
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/EasyUserManagement.svg" alt="簡単なユーザー管理 - 文法 チェック" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>簡単なユーザー管理</h3>
                            <p>Trinka Enterpriseのアカウントでは、メンバーの追加や削除も簡単。ポイント（Credit）や利用限度額をリアルタイムに管理できます。Trinkaのきめ細かなコントロール機能によりアクセス管理は簡単かつ安全に行えます。
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="盗用・剽窃チェック - 英文チ ェッカー" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>盗用・剽窃チェック</h3>
                            <p>iThenticateが誇る最先端のテキスト類似性検出アルゴリズムと、最大級の有料出版物データベースによる高品質の盗用・剽窃チェック
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1 ">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="総合的な分析 - 文法 チェック" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>総合的な分析</h3>
                            <p>Trinkaの利用状況や、各ユーザーの行動を掘り下げて分析することで、効果的な意思決定を行えます。
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                        <div class="features_cards_icon">
                            <img src="../../../assets/images/DedicatedSupport.svg" alt="献身的なサポート - 英文校正" srcset="">
                        </div>
                        <div class="features_cards_desc">
                            <h3>手厚いサポート体制</h3>
                            <p>専任のスタッフが、お客様のチームにTrinkaを最大限に活用いただけるようサポートします。これには、チームに新たに加わったメンバーに対する細やかなオリエンテーション、マニュアルやビデオウォークスルーが含まれます。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            

        </div>
    </div>

</div>

<div class="whiteListing section-pd">
    <div class="trinka_container">
        <div class="row align-items-center" style="margin-bottom: 40px;">
            <div class="col-md-8 col-sm-8">
                <div class="trinka-title mb-0">
                    <h2>IPホワイトリスト</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>IPホワイトリストとは、機密データやシステムを不正アクセスから保護するためのセキュリティ機能です。リソースの閲覧者を制御することで低コストで効果的にセキュリティ強化を行えるため、機密データを扱う組織で活用されています。ホワイトリストはブラックリストの逆で、信頼できる特定のIPアドレスのみにアクセス権を付与する機能です。</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-4">
                <div class="benefitImage">
                    <img src="../../../assets/images/the-benefit-whitepaper.png" width="200" alt="IPホワイトリスト - 文法 チェック" class="img-fluid" />
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-8 col-sm-12">
                <div class="trinka-title mb-0">
                    <h3 class="mb-2">メリット</h3>
                    <p>IP ホワイトリストには以下のようなメリットがあります。</p>
                </div>
            </div>
            
        </div>
        <div class="row match-box">
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>セキュリティの強化 <span><img src="../../../assets/images/icons/cyber-security.png" alt="セキュリティの強化 - 英文チ ェッカー" /></span></h4>
                        <p>信頼できるIPアドレスからのみTrinkaにアクセスできるため、不正アクセスやサイバー攻撃のリスクを軽減できます。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>管理者によるコントロール <span><img src="../../../assets/images/icons/browser.png" alt="管理者によるコントロール - 文法 チェック" /></span></h4>
                        <p>管理者がIPアドレスの指定および指定解除をすることで、Trinkaにアクセスできるユーザーを制御できます。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>ダウンタイムの削減 <span><img src="../../../assets/images/icons/clock.png" alt="ダウンタイムの削減 - 英文校正 ai" /></span></h4>
                        <p>指定IP以外からのアクセスができないため、ユーザーに影響を与える可能性のあるDoS攻撃やアクセス集中のリスクも低減できます。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>コンプライアンスの向上 <span><img src="../../../assets/images/icons/growth.png" alt="コンプライアンスの向上 - ai英文校正" /></span></h4>
                        <p>個人情報をはじめ、厳密な管理が組織に求められる情報を保全することができるため、コンプライアンスの向上にもつながります。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases section-purple rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-11 col-lg-10">
                            <div class="trinka-title mb-0 text-center">
                                <h2>幅広い英文執筆に対応</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                                <p>分野や業界、目的に合わせて、Trinkaの優れた機能をご活用ください。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards  bt-none">
                                <h3>コンテンツ編集者の強い味方</h3>
                                <p>Trinkaが文法や高度な専門用語などの問題を修正し、校正者はより大枠での表現の編集に集中できます。ワークフローを効率化しながら、より質の高いコンテンツに仕上げられます。</p>
                                <ul>
                                    <li>プロジェクトの納期短縮</li>
                                    <li>編集・校正品質の向上</li>
                                    <li>出版や記事の公開の迅速化</li>
                                        
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>マーケティングの効率化</h3>
                                <p>Trinkaを利用すると顧客向けメールやマーケティング資料、広報資料、レポート、ピッチなどが効率的に作成できます。</p>
                                <ul>
                                    <li>顧客とのコミュニケーションでのミス防止</li>
                                    <li>ブランドイメージに沿った発信</li>
                                    <li>コンテンツ制作の時間短縮</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>コンテンツの品質評価</h3>
                                <p>TrinkaのAIライティング評価を使えば、カテゴリー別ミスの分類など数値的な指標で文章の長所と短所が分かります。</p>
                                <ul>
                                    <li>品質に関する数値的データ取得</li>
                                    <li>コンテンツの編集・制作能力の査定</li>
                                    <li>解説とヒントによるライティング学習</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>翻訳後の自動文法チェック</h3>
                                <p>Trinkaを使えば翻訳した英文の品質も確認でき、文法・表現の改善が可能です。</p>
                                <ul>
                                    <li>文脈に応じたスペルチェック</li>
                                    <li>技術的な言い回しや文構造の改善</li>
                                    <li>大規模プロジェクトに適したファイル自動校正</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="cloud_key_features section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>どこにいても使えるライティングツール</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>TrinkaはブラウザからMicrosoft Wordまで幅広いプラットフォーム上での英文ライティングをサポートします。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>Trinka Cloud（クラウドベース）</h3>
                    <p>
                        セキュリティで保護されたWebベースのチェッカーで、どこからでもTrinkaを最大限に活用できます。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>Word プラグイン</h3>
                    <p>
                        Wordのファイル内にリアルタイムで修正案が提示され、チームの作業効率をアップ。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>ブラウザ プラグイン</h3>
                    <p>
                        各種ブラウザへのプラグインで、あらゆるサイトに入力する英文をリアルタイムにチェック。
                    </p>
                </div>
            </div>
            
        </div>
    </div>
</div>

<div class="section-pd section-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>まずはお気軽にお問い合わせください</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinkaは、お客様独自のニーズに合わせ、ユーザー単位や使用量に応じた柔軟な価格設定を行っています。ユーザーの移行や利用制限をリアルタイムに行うことができ、追加料金もかかりません。お客様のご事情にあわせた契約で、請求書ベースでのお支払いも可能です。</p>
                    <div class="btn-group justify-content-center mt-4">
                        <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お見積もり</button>
                        <a href="https://calendly.com/trinkaai/meet" target="_blank"  id="autoEditGetStart" class="outline-btn">デモを予約する</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-6 col-lg-6">
                <div class="trinka-title">
                    <h3 class="text-white mb-4">Trinkaのお支払いは、日本円でのお振込みにも対応</h3>
                    <p class="text-white">銀行振り込みでのご利用料金のお支払いをご希望のお客様には請求書をお送りしています。適格請求書がご入用な場合、お気軽にお申し付けください。日本での販売代理店である株式会社クリムゾンインタラクティブ・ジャパンが、日本円建ての適格請求書を発行いたします。</p>
                </div>
                <div class="btn-group">
                    <a [routerLink]="['/local-invoice']" class="white-btn">請求書の詳細を見る</a>
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                <div class="text-center mt-sm-30">
                    <img src="../../../assets/images/local-inovice-element.png" alt="現地の請求書 - 英文校正" class="img-fluid" />
                </div>
            </div>
        </div>  
    </div>
</div>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>万全のセキュリティ</h3>
                    <p>Trinkaは、データの安全性とプライバシーを最重視した設計になっています。お客様のデータは高度に暗号化され、安全に保管されます。第三者がお客様のデータにアクセスすることはありません。ライティングの提案後に、データを完全に抹消するプランもご用意しています。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/safe-secure.png" alt="万全のセキュリティ - 文法 チェック" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>AIについて</h3>
                    <p>Trinkaは、コミュニケーションの障壁がない未来を願って、言語学者、医学校正者、データサイエンティスト、エンジニアらのチームによって開発されました。</p>
                    <p>Trinkaは、最新の機械学習（ML）と自然言語処理（NLP）の技術を使用して、文法の誤りを特定し、言語の改善案を提案します。医学、ライフサイエンス、生物学、物理科学、工学、人文科学、ビジネス、芸術を含む1300以上の分野の上質な論文や記事を数百万単位で読み込むことでAIが学習し、最適な提案をします。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/about-ai.png" alt="AIについて -  英文校正" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>


<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinkaで、新しいビジネスコミュニケーションを</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
                    class="white-btn" type="submit">お問い合わせ</button>
                </div>
            </div>
        </div>  
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>